import React, { useEffect, useState } from "react";
import "../../../../Assets/CSS/bulkorder.css";
import "../../oms.css";
import Up from "../../../../Assets/Images/OMS/up.svg";
import Down from "../../../../Assets/Images/OMS/down.svg";
import Product from "../../../../Assets/Images/OMS_New/product (1).svg";
import { useFormik } from "formik";

function ProductDetailsBuyerForm({ omsData }) {
  const [buyerProductDetails, setBuyerProductDetails] = useState(false);

  const initialValues = {
    product_name: "",

    variety: "",
    moisture: "",
    quantity: "",
    unit_price: "",
    gst: "",
    total_amount: "",
    damaged_grains: "",
    discolored_grains: "",
    bag_quantity: "",
  };

  const validate = (values) => {
    const errors = {};
    if (!values.supplier_Name) {
      errors.supplier_Name = " Supplier name is required";
    } else if (values.supplier_Name.length > 35) {
      errors.firstName = "Must be 35 characters or less";
    }

    return errors;
  };
  const formik = useFormik({
    initialValues: initialValues,
    validate,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  useEffect(() => {
    formik.setValues({
      ...formik.values,
      product_name: omsData?.order_items?.[0]?.product?.product_name
        ? omsData?.order_items?.[0]?.product?.product_name
        : "NA",
      moisture: omsData?.order_items?.[0]?.product?.quality_parameter?.moisture
        ? omsData?.order_items?.[0]?.product?.quality_parameter?.moisture
        : "NA",
      gst: omsData?.order_items?.[0]?.product?.gst
        ? omsData?.order_items?.[0]?.product?.gst
        : "NA",
      quantity: omsData?.order_items?.[0]?.new_quantity
        ? omsData?.order_items?.[0]?.new_quantity
        : "NA",
      uom: omsData?.op_sourcing_details?.[0]?.measurement_unit,
      unit_price:
        omsData?.order_items?.[0]?.product?.selling_price &&
        omsData?.order_items?.[0]?.product?.gst
          ? omsData?.order_items[0]?.product?.selling_price -
            omsData?.order_items[0]?.product?.gst
          : "NA",
      total_amount: omsData?.total_amount ? omsData?.total_amount : "NA",
      variety: omsData?.order_items?.[0]?.product?.quality_parameter?.variety
        ? omsData?.order_items?.[0]?.product?.quality_parameter?.variety
        : "NA",
      damaged_grains: omsData?.order_items?.[0]?.product?.quality_parameter
        ?.damaged_grains
        ? omsData?.order_items?.[0]?.product?.quality_parameter?.damaged_grains
        : "NA",
      discolored_grains: omsData?.order_items?.[0]?.product?.quality_parameter
        ?.discoloured_grains
        ? omsData?.order_items?.[0]?.product?.quality_parameter
            ?.discoloured_grains
        : "NA",
        hsn_code: omsData?.order_items?.[0]?.product?.hsn_code
    });
  }, [omsData, formik.setValues]);

  return (
    <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
      <div className="flex flex-col sm:flex-row justify-between">
        <div className="font-medium text-cyan-950 text-md flex gap-2">
          {" "}
          <img src={Product} alt="" />
          <div> Product Details</div>
        </div>
        <div>
          {buyerProductDetails ? (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Up}
                alt=""
                role="button"
                onClick={() => setBuyerProductDetails(!buyerProductDetails)}
              />
            </div>
          ) : (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Down}
                alt=""
                role="button"
                onClick={() => setBuyerProductDetails(!buyerProductDetails)}
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
      </div>
      <div>
        {buyerProductDetails ? (
          <></>
        ) : (
          <div>
            <form onSubmit={formik.handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                <div>
                  <label
                    for="product_name"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Product Name
                  </label>
                  <input
                    type="text"
                    id="product_name"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="product_name"
                    value={formik.values.product_name}
                    disabled
                  />
                  {formik.errors.product_name ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.product_name}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="uom"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Unit Of Measurement
                  </label>
                  <input
                    type="text"
                    id="uom"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="uom"
                    value={formik?.values?.uom}
                    disabled
                  />
                </div>
                <div>
                  <label
                    for="variety"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Variety
                  </label>
                  <input
                    type="text"
                    id="variety"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="variety"
                    value={formik.values.variety}
                    disabled
                  />
                  {formik.errors.variety ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.variety}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="damaged_grains"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Damage Grains
                  </label>
                  <input
                    type="text"
                    id="damaged_grains"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="damaged_grains"
                    value={formik.values.damaged_grains}
                    disabled
                  />
                  {formik.errors.damaged_grains ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.damaged_grains}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="discolored_grains"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Discolored Grains
                  </label>
                  <input
                    type="text"
                    id="discolored_grains"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="discolored_grains"
                    value={formik.values.discolored_grains}
                    disabled
                  />
                  {formik.errors.discolored_grains ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.discolored_grains}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="moisture"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Moisture
                  </label>
                  <input
                    type="text"
                    id="moisture"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="moisture"
                    value={formik.values.moisture}
                    disabled
                  />
                  {formik.errors.moisture ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.moisture}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="hsn_code"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    HSN Code
                  </label>
                  <input
                    type="text"
                    id="hsn_code"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="hsn_code"
                    value={formik.values.hsn_code}
                    disabled
                  />
                </div>
                <div>
                  <label
                    for="quantity"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Quantity
                  </label>
                  <input
                    type="text"
                    id="quantity"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="quantity"
                    value={formik.values.quantity}
                    disabled
                  />
                  {formik.errors.quantity ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.quantity}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="unit_price"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Unit Price (Rs)
                  </label>
                  <input
                    type="text"
                    id="unit_price"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="unit_price"
                    value={formik.values.unit_price}
                    disabled
                  />
                  {formik.errors.unit_price ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.unit_price}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="gst"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    GST(Amount)
                  </label>
                  <input
                    type="text"
                    id="gst"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="gst"
                    value={formik.values.gst}
                    disabled
                  />
                  {formik.errors.gst ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.gst}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="total_amount"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Total Amount
                  </label>
                  <input
                    type="text"
                    id="total_amount"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="total_amount"
                    value={formik.values.total_amount}
                    disabled
                  />
                  {formik.errors.total_amount ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.total_amount}
                    </div>
                  ) : null}
                </div>
                {/* <div>
                  <label
                    for="bag_quantity"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Bag Quantity
                  </label>
                  <input
                    type="text"
                    id="bag_quantity"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="bag_quantity"
                    value={formik.values.bag_quantity}
                    disabled
                  />
                </div> */}
                {/* <div>
                  <label
                    for="Other"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Other
                  </label>
                  <input
                    type="text"
                    id="Other"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="Other"
                    value={formik.values.other}
                    disabled
                  />
                </div> */}
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProductDetailsBuyerForm;
